module.exports = __webpack_public_path__ + "static/media/another_future.15a8fd2d.jpeg";